export default "__VITE_ASSET__BqgbQguL__"